import { useConfirmationStore } from '@/components/dialog/confirmation.store';
import { Form, useForm } from '@/components/forms';
import Input from '@/components/forms/Input';
import { nameValidationRegex } from '@/constants/regex';
import { useDynamicLocale } from '@/hoslog-intl';
import { z } from 'zod';
import { useVisitCodeConfirmation } from './hooks/useVisitCodeConfirmation';

const visitCodeFormSchema = z.object({
  visitCode: z
    .string()
    .min(1, { message: 'common.form.validation.required' })
    .regex(nameValidationRegex, 'common.form.validation.nameOnly'),
});

export const VisitCodeConfirmation = ({ reservationId, clubId }: { reservationId: string; clubId: string }) => {
  const form = useForm({ schema: visitCodeFormSchema, mode: 'onBlur' });

  const { t } = useDynamicLocale();
  const { openConfirmation } = useConfirmationStore();

  const { mutateAsync } = useVisitCodeConfirmation();

  return (
    <Form
      form={form}
      onSubmit={(data) => {
        openConfirmation({
          title: t('dashboard.reservationLedger.modal.confirmation'),
          description: t('dashboard.reservationLedger.modal.confirmation.message'),
          cancelLabel: t('common.page.modal.no'),
          actionLabel: t('common.page.modal.confirm'),
          size: 'lg',
          onAction: async () => {
            await mutateAsync({
              otpCode: data.visitCode,
              reservationId: reservationId,
              clubId: clubId,
            });
          },
          onCancel: () => {},
        });
      }}
    >
      <Input
        label="dashboard.reservationLedger.modal.form.visitCode"
        placeholder={t('dashboard.reservationLedger.modal.form.placeholder')}
        {...form.register('visitCode')}
        maxLength={6}
        forceRequired
      />
    </Form>
  );
};
